<template>
  <!-- <div class="card-container"> -->
  <div class="card pos-c">
    <i class="close" @click="$emit('close')"/>
    <div class="content">
      <img :src="require(`../../../assets/img/Representative/${builder}.png`)" alt="">
      <div class="info">
        <d-player v-if="info.video" ref="player" :url="require(`../../../assets${info.video}`)" @canplay="play"/>
        <h3 v-show="info.profile">人物简介</h3>
        <p v-for="text in profile" :key="text">{{ text }}</p>
        <h3 v-show="info.achievement">建设事迹</h3>
        <p v-for="text in achievement" :key="text">{{ text }}</p>
        <h3 v-show="info.personalReflections">个人感言</h3>
        <p v-for="text in personalReflections" :key="text">{{ text }}</p>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import msg from './data'

export default {
  name: 'Card',
  props: {
    builder: {
      type: String,
      required: true,
    },
  },
  computed: {
    info () {
      return msg[this.builder] || {}
    },
    profile () {
      if (!this.info.profile) {
        return []
      }
      return Array.isArray(this.info.profile) ? this.info.profile : [this.info.profile]
    },
    achievement () {
      if (!this.info.achievement) {
        return []
      }
      return Array.isArray(this.info.achievement) ? this.info.achievement : [this.info.achievement]
    },
    personalReflections () {
      if (!this.info.personalReflections) {
        return []
      }
      return Array.isArray(this.info.personalReflections) ? this.info.personalReflections : [this.info.personalReflections]
    },
  },
  mounted () {
    if (this.info.video) {
      this.$bgAudio.pause()
    }
  },
  beforeDestroy () {
    if (this.info.video) {
      this.$bgAudio.play()
    }
  },
  methods: {
    play () {
      this.$nextTick(() => {
        this.$refs.player.play()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  padding: 0.35rem 0.5rem;
  margin-top: -0.03rem;
  border-radius: 0.3rem;
  background-image: url(./img/card-bg.png);
  background-size: cover;
  .close {
    position: absolute;
    top: -0.5rem;
    right: -0.5rem;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background-image: url(../../../assets/img/icon/close.png);
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 12;
  }
  .content {
    width: 12rem;
    height: 6.3rem;
    img {
      height: 100%;
    }
    .info {
      display: inline-block;
      vertical-align: top;
      width: 7.07rem;
      height: 100%;
      margin-left: 0.5rem;
      overflow: auto;
      h3 {
        margin: 0.2rem 0;
        font-size: 0.26rem;
        font-weight: bold;
        color: #333;
      }
      p {
        margin: 0.1rem 0;
        padding-right: 0.2rem;
        font-size: 0.22rem;
        line-height: 1.4;
        text-indent: 0.44rem;
      }
    }
  }
}
</style>
